import { gql } from "@apollo/client";

const ECOM_UPDATE_QUOTE_MUTATION = gql`
    mutation updateQuote(
        $cart_id: String!
        $storeId: Int!
        $customerType: String!
        $accountNumber: Int
        $jobNumber: String
        $driverLicenseState: String
        $driverLicenseNumber: String
        $isDelivery: Boolean
        $deliveryInstructions: String
        $startDateTime: String
        $endDateTime: String
        $earliestDateTime: String
        $purchaseOrderNumber: String
        $optOutRPP: String
        $optOutFuelCharge: String
        $deliveryCharge: Float
        $pickUpCharge: Float
        $orderByEmail: String
        $orderedBy: String
        $areaCode: String
        $phoneNumber: String
        $address1: String
        $address2: String
        $city: String
        $state: String
        $zip: String
        $distance: Float
        $rentalssubtotal: String
        $purchasesubtotal: String
        $rentalprotectplan: String
        $fuelconvenienceplan: String
        $envirofee: String
        $otherfees: String
        $taxes: String
        $subtotal: String
        $totalcost: String
        $products: [UpdateQuoteProducts]!
        $salesItems: [UpdateQuoteSalesItems]
        $channel: String!
        $quoteId: String!
    ) {
        ecomUpdateQuote(
            input: {
                cart_id: $cart_id
                storeId: $storeId
                customerType: $customerType
                accountNumber: $accountNumber
                jobNumber: $jobNumber
                driverLicenseState: $driverLicenseState
                driverLicenseNumber: $driverLicenseNumber
                isDelivery: $isDelivery
                deliveryInstructions: $deliveryInstructions
                startDateTime: $startDateTime
                endDateTime: $endDateTime
                earliestDateTime: $earliestDateTime
                purchaseOrderNumber: $purchaseOrderNumber
                optOutRPP: $optOutRPP
                optOutFuelCharge: $optOutFuelCharge
                deliveryCharge: $deliveryCharge
                pickUpCharge: $pickUpCharge
                orderByEmail: $orderByEmail
                orderedBy: $orderedBy
                areaCode: $areaCode
                phoneNumber: $phoneNumber
                address1: $address1
                address2: $address2
                city: $city
                state: $state
                zip: $zip
                distance: $distance
                rentalssubtotal: $rentalssubtotal
                purchasesubtotal: $purchasesubtotal
                rentalprotectplan: $rentalprotectplan
                fuelconvenienceplan: $fuelconvenienceplan
                envirofee: $envirofee
                otherfees: $otherfees
                taxes: $taxes
                subtotal: $subtotal
                totalcost: $totalcost
                products: $products
                salesItems: $salesItems
                channel: $channel
                quoteId: $quoteId
            }
        ) {
            message
            quoteId
        }
    }
`;

export default ECOM_UPDATE_QUOTE_MUTATION;